import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { sizes, positions } from "./constants";

export default function MonogramStepSize({
  product,
  config,
  setConfig,
  setVisible,
}) {
  const updateSize = (size) => setConfig({ ...config, size: size });

  const handleChange = (e) => {
    updateSize(e.target.value);
  };

  let availableSizes = Object.keys(sizes);

  if (product.monogramSettings.sizeOptions !== null) {
    availableSizes = JSON.parse(product.monogramSettings.sizeOptions).map(
      (size) => size.toLowerCase(),
    );
  }

  if (!config.size) {
    const isSide = config.position === positions.side;
    const defaultSize =
      availableSizes.find((size) => size === "medium") || availableSizes[0];
    const initialSize = isSide ? availableSizes[0] : defaultSize;

    updateSize(initialSize);
  }

  if (availableSizes.length < 2) {
    setVisible(false);
    return null;
  }

  setVisible(true);

  return (
    <div className="monogram-config__sizes">
      {availableSizes.map((size) => (
        <label className="monogram-config__size-label monogram-config__radio-label">
          <input
            className="monogram-config__size-input monogram-config__radio-input"
            type="radio"
            name="monogram-size"
            checked={config.size === size}
            onChange={handleChange}
            value={size}
          />
          <div class="monogram-config__size-value">{sizes[size]}</div>
        </label>
      ))}
    </div>
  );
}
